import { Money } from "models/money";

export function getExcelData(data) {
  // param: data list of: [
  // {
  //   empresa: 'BIOALIMENTAR CIA. LTDA.',
  //   venta1: 59435181,
  //   sector: 'GANADERÍA / AVICULTURA / PEQUEÑAS ESPECIES / MICELÁNEOS',
  //   $$hashKey: 'uiGrid-000V'
  // }]
  let rows = [];
  data.forEach((elem, index) => {
    var _known = {
      Numero: index + 1,
      Empresa: elem.empresa,
      Sector: elem.sector,
      Total: Money(elem.venta1),
    };
    rows.push(_known);
  });
  return rows;
}
